<template>
  <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="branchs.isLoading">
    <el-row type="flex" justify="space-between" align="middle" class="mb-4">
      <p class="category-title ma-0">Branch</p>
      <el-col :span="16">
        <el-row type="flex" justify="end">
          <el-select
            v-model="optionView"
            size="small"
            placeholder="Select"
            @change="
            e => {
              toAnotherPage(page, e), settingTable(page, e);
            }
          "
            class="mr-2"
            style="width: 100px"
          >
            <el-option
              v-for="item in optionsView"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            size="small"
            v-model="form.search"
            placeholder="Search by name or code"
            style="width: 200px"
            class="mr-2"
            @keyup.enter.native="onSearch"
          ></el-input>

          <el-button type="primary" @click="onSearch" size="small">Search</el-button>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-table empty-text="Tidak ada data" :data="branchs.data" style="width: 100%">
        <el-table-column type="index" label="No" width="80"></el-table-column>
        <el-table-column sortable prop="GM" label="GM" width="180"></el-table-column>
        <el-table-column sortable prop="NOM" label="NOM"></el-table-column>
        <el-table-column sortable prop="RGM" label="RGM"></el-table-column>
        <el-table-column sortable prop="RGM_name" label="RGM Name" width="180"></el-table-column>
        <el-table-column sortable prop="branch" label="Branch" width="180"></el-table-column>
        <el-table-column sortable prop="subbranch" label="Sub Branch" width="180"></el-table-column>
        <el-table-column sortable prop="warehouse_id" label="Warehouse ID" width="180"></el-table-column>
        <el-table-column sortable prop="address" label="Address" width="200">
          <template slot-scope="scope">
            <span class="truncate-text">{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="state" label="State" width="180"></el-table-column>
        <el-table-column sortable prop="city" label="City" width="180"></el-table-column>
        <el-table-column sortable prop="province" label="Province" width="180"></el-table-column>
        <el-table-column sortable prop="country" label="Country" width="180"></el-table-column>
        <el-table-column sortable prop="postal_code" label="Postal Code" width="180"></el-table-column>
        <el-table-column sortable prop="latitudes" label="Latitudes" width="180"></el-table-column>
        <el-table-column sortable prop="longitudes" label="Longitudes" width="180"></el-table-column>
      </el-table>
      <el-row type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :total="branchs.count"
          :current-page="parseInt(page)"
          @current-change="
            e => {
              toAnotherPage(e, optionView), settingTable(e, optionView);
            }
          "
          :page-size="parseInt(optionView)"
        ></el-pagination>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        search: ""
      },
      optionsActive: [
        {
          value: "A",
          label: "Active"
        },
        {
          value: "I",
          label: "No Active"
        }
      ],
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      page: 1
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getBranch: "branch/GetBranchs",
      deleteBranch: "branch/DeleteBranch"
    }),
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    handleDelete(idx, row) {
      this.$confirm(
        "This will permanently delete the file. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.deleteBranch(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          });
        });
    },
    toAnotherPage(page, limit) {
      this.$router.push({ path: "/branch", query: { page: page, limit: limit } });
    },
    onSearch() {
      this.$router.replace({ path: "/branch", query: { page: 1, limit: 25 } })
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getBranch(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView
        }
      };
      this.getBranch(option);
    },
  },
  computed: {
    ...mapState({
      branchs: state => state.branch.branchs
    })
  },
  created() {
    this.page = this.$router.history.current.query.page;
    this.optionView = this.$router.history.current.query.limit;
    let option = {
      params: {
        page: this.page,
        limit: this.optionView
      }
    };
    this.getBranch(option);
  }
};
</script>

<style>
.branch-title {
  text-align: left;
  font-size: 1.5rem;
}
</style>
